module.exports = __webpack_public_path__ + "static/agile-c2f952adb83f2c0256434d20bb2a4601.png";